
    module.exports = function cssToMuiLoader(theme) {
      
      return {
        
        'root': {'flexGrow': `1`,'backgroundColor': `#ffffff`,'padding': `20px`,'minHeight': `5vh`,'boxShadow': `0 2px 4px 0 rgba(0, 0, 0, 0.2)`,},'sticky': {'flexGrow': `1`,'backgroundColor': `#ffffff`,'padding': `20px`,'minHeight': `5vh`,'boxShadow': `0 2px 4px 0 rgba(0, 0, 0, 0.2)`,'position': `fixed`,'top': `0`,'width': `100%`,'display': `flex`,'justifyContent': `center`,'padding': `0 20px`,'backgroundColor': `#ffffff`,},'tabsComponent': {'indicatorColor': `primary`,'textColor': `primary`,'centered': `false`,'scrollable': `true`,},'tabs': {'minHeight': `5vh`,},'tab': {'fontFamily': `'Lato-Regular-Regular', sans-serif`,},'selected': {'fontWeight': `bold`,},'moreButton': {'paddingTop': `16px`,'color': `#000000`,},'menu': {'width': `'35ch'`,},
        
      };
    };
  